import { z } from 'zod';

export const metadataSchema = z.object({
	date: z.string(),
	hash: z.string()
});
